const uniqBy = (array, field) => {
  const keyValuePairs = array.map(item => [item[field], item]);
  return Array.from(new Map(keyValuePairs).values());
};

export default uniqBy;
